export default __webpack_public_path__ + "static/media/usa-lacrosse.6e24db89.svg";